import { responseModels } from "./fixtures/modelli";

export type ModelListMode = "available" | "error" | "empty";
export type ResponseModel = { id: string; name: string; description: string; recommended: boolean };

const wait = (milliseconds: number) => new Promise<void>((resolve) => window.setTimeout(resolve, milliseconds));

export async function listResponseModels(mode: ModelListMode = "available"): Promise<ResponseModel[]> {
  await wait(350);
  if (mode === "error") throw new Error("L’elenco dei modelli non è disponibile.");
  if (mode === "empty") return [];
  return responseModels.map((model) => ({ ...model }));
}
